import type { ICellRendererParams } from 'ag-grid-community';
import { CustomCellEditorProps } from 'ag-grid-react';
import { CustodiansSearchField } from 'components/secondaryMarket/shared/Custodians/CustodiansSearchField';
import { Custodian } from 'models/custodian';
import { FC } from 'react';
import { htmlDecode } from 'utils/html-decode';

export const CustodianCellEditor = ({ value, onValueChange }: CustomCellEditorProps<unknown, Custodian>) => {
  return <CustodiansSearchField onCustodianChanged={onValueChange} selectedCustodian={value ?? undefined} />;
};

export const CustodianCellRenderer: FC<ICellRendererParams<unknown, Custodian>> = ({ value }) => {
  if (!value) {
    return null;
  }
  const custodianDisplay = htmlDecode(`${value.label} (${value.id} - ${value.eliotCode})`);
  return <span>{custodianDisplay}</span>;
};
